import httpClient from "./httpClient";
import { ANIMAL_SPLIT_CORE } from "../constants";

const API_BASE_URL = ANIMAL_SPLIT_CORE[process.env.NODE_ENV].URL;

/**
 * Abstract room management service
 * Game-agnostic operations for room lifecycle
 * For seat operations, use SeatService.js
 * For Texas poker operations, use TexasService.js
 */

/**
 * Create a new room
 * @param {object} roomData - Room configuration
 */
export const createRoom = async (roomData) => {
  const response = await httpClient.post(`${API_BASE_URL}/api/v0/room`, roomData);
  return response.data;
};

/**
 * Get room details
 * @param {string} roomId - Room ID
 */
export const getRoom = async (roomId) => {
  const response = await httpClient.get(`${API_BASE_URL}/api/v0/room/${roomId}`);
  return response.data;
};

/**
 * Update room metadata
 * @param {string} roomId - Room ID
 * @param {object} updateData - Data to update
 */
export const updateRoom = async (roomId, updateData) => {
  const response = await httpClient.patch(`${API_BASE_URL}/api/v0/room/${roomId}`, updateData);
  return response.data;
};

/**
 * Update game state
 * @param {string} roomId - Room ID
 * @param {object} gameState - New game state
 */
export const updateGameState = async (roomId, gameState) => {
  const response = await httpClient.patch(`${API_BASE_URL}/api/v0/room/${roomId}/game-state`, gameState);
  return response.data;
};

/**
 * List all rooms with optional filters
 * @param {string} gameType - Filter by game type
 * @param {string} status - Filter by status
 */
export const listRooms = async (gameType, status) => {
  const params = new URLSearchParams();
  if (gameType) params.append('gameType', gameType);
  if (status) params.append('status', status);
  
  const response = await httpClient.get(`${API_BASE_URL}/api/v0/room?${params.toString()}`);
  return response.data;
};
